import CloudUploadSharpIcon from '@mui/icons-material/CloudUploadSharp';
import { Badge, Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { bytesToMegabytes } from '@utils/transform';
import { FunctionComponent, useState } from 'react';

export type UploadFilesProps = {
  maxFiles: number;
  maxFileSizeMB: number;
  onFilesSelected: (files: File[]) => void;
};

export const UploadFiles: FunctionComponent<UploadFilesProps> = (props) => {
  const { maxFileSizeMB, maxFiles, onFilesSelected } = props;
  const [filesSelected, setFilesSelected] = useState(0);
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const files = Array.from(event.target.files)
        .filter((file) => bytesToMegabytes(file.size) <= maxFileSizeMB)
        .slice(0, maxFiles);
      setFilesSelected(files.length);
      onFilesSelected(files);
    }
  };

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      flex={1}
    >
      <Badge badgeContent={`${filesSelected}/${maxFiles}`} color="primary">
        <Button
          variant="outlined"
          startIcon={<CloudUploadSharpIcon />}
          component="label"
        >
          Upload
          <input hidden multiple type="file" onChange={onChange} />
        </Button>
      </Badge>
      <Typography variant="caption">{`Max file upload size: ${maxFileSizeMB}MB`}</Typography>
    </Stack>
  );
};
